export const activationDistCsvFilter = (role, lmtd, tile, content) => {
    let csv = content;
    ({
      ZD: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ZD"] = obj["zd"] ?? "";
                obj["ZD Name"] = obj["zdName"] ?? "";
                obj["RDS"] = obj["parentId"] ?? "";
                obj["RDS Name"] = obj["parentName"] ?? "";
                obj["Retailer"] = obj["retailerId"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JPR type Name"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["retailerCnt"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ZD"] = obj["zd"] ?? "";
                obj["ZD Name"] = obj["zdName"] ?? "";
                obj["RDS"] = obj["rds"] ?? "";
                obj["RDS Name"] = obj["rdsName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                obj["Retailer"] = obj["retailerId"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["Status"] = obj["status"] ?? "";
                obj["LMTD Status"] = obj["lmtdBilled"] ?? "";
                obj["Billed Status"] = obj["mtdBilled"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["jprTypeName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["status"];
                delete obj["lmtdBilled"];
                delete obj["mtdBilled"];
                delete obj["ard"];
                delete obj["ardName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                return obj;
              });
            return csv;
          },
        }[tile]());
        return csv;
      },
      CHAIN: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["CHAIN Code"] = obj["chainId"] ?? "";
                obj["CHAIN Name"] = obj["chainName"] ?? "";
                obj["Store Code"] = obj["storeId"] ?? "";
                obj["Store Name"] = obj["storeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["chainId"];
                delete obj["chainName"];
                delete obj["storeId"];
                delete obj["storeName"];
                delete obj["zdmt"];
                delete obj["zdmtName"];
                delete obj["status"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            ({
              YES: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Chain Code"] = obj["chainId"] ?? "";
                    obj["Chain Name"] = obj["chainName"] ?? "";
                    obj["Store Code"] = obj["storeId"] ?? "";
                    obj["Store Name"] = obj["storeName"] ?? "";
                    obj["Status"] = obj["status"] ?? "";
                    obj["MTD Distribution"] = obj["mtdBilled"] ?? "";
                    obj["LMTD Distribution"] = obj["lmtdBilled"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["chainId"];
                    delete obj["chainName"];
                    delete obj["storeId"];
                    delete obj["storeName"];
                    delete obj["status"];
                    delete obj["mtdBilled"];
                    delete obj["lmtdBilled"];
                    delete obj["zdmt"];
                    delete obj["zdmtName"];
                    return obj;
                  });
                return csv;
              },
              NO: () => {},
            }[lmtd]());
            return csv;
          },
        }[tile]());
        return csv;
      },
      ARD: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jioCenter"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ARD Code"] = obj["parentId"] ?? "";
                obj["ARD Name"] = obj["parentName"] ?? "";
                obj["UAO Code"] = obj["retailerId"] ?? "";
                obj["UAO Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                obj["Count"] = obj["retailerCnt"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["retailerCnt"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jioCenter"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["ARD Code"] = obj["ard"] ?? "";
                obj["ARD Name"] = obj["ardName"] ?? "";
                obj["UAO Code"] = obj["retailerId"] ?? "";
                obj["UAO Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                obj["Status"] = obj["status"] ?? "";
                obj["LMTD Status"] = obj["lmtdBilled"] ?? "";
                obj["Billed Status"] = obj["mtdBilled"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["ard"];
                delete obj["ardName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtdBilled"];
                delete obj["mtdBilled"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                return obj;
              });
            return csv;
          },
        }[tile]());
        return csv;
      },
      ZDMT: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ZDMT"] = obj["zdmt"] ?? "";
                obj["ZDMT Name"] = obj["zdmtName"] ?? "";
                obj["Chain Code"] = obj["chainId"] ?? "";
                obj["Chain Name"] = obj["chainName"] ?? "";
                obj["Store Code"] = obj["storeId"] ?? "";
                obj["Store Name"] = obj["storeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zdmt"];
                delete obj["zdmtName"];
                delete obj["chainId"];
                delete obj["chainName"];
                delete obj["storeId"];
                delete obj["storeName"];
                delete obj["status"];
                return obj;
              });
          },
          onboard: () => {
            ({
              YES: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zdmt"] ?? "";
                    obj["ZDMT Name"] = obj["zdmtName"] ?? "";
                    obj["Chain Code"] = obj["chainId"] ?? "";
                    obj["Chain Name"] = obj["chainName"] ?? "";
                    obj["Status"] = obj["status"] ?? "";
                    obj["MTD Distribution"] = obj["mtdBilled"] ?? "";
                    obj["LMTD Distribution"] = obj["lmtdBilled"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zdmt"];
                    delete obj["zdmtName"];
                    delete obj["chainId"];
                    delete obj["chainName"];
                    delete obj["status"];
                    delete obj["mtdBilled"];
                    delete obj["lmtdBilled"];
                    delete obj["storeId"];
                    delete obj["storeName"];
                    return obj;
                  });
                return csv;
              },
              NO: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zdmt"] ?? "";
                    obj["ZDMT Name"] = obj["zdmtName"] ?? "";
                    obj["Chain Code"] = obj["chainId"] ?? "";
                    obj["Chain Name"] = obj["chainName"] ?? "";
                    obj["Status"] = obj["status"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zdmt"];
                    delete obj["zdmtName"];
                    delete obj["chainId"];
                    delete obj["chainName"];
                    delete obj["status"];
                    delete obj["mtdBilled"];
                    delete obj["lmtdBilled"];
                    delete obj["storeId"];
                    delete obj["storeName"];
                    return obj;
                  });
              },
            }[lmtd]());
            return csv;
          },
        }[tile]());
        return csv;
      },
      RDS: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ZD"] = obj["zd"] ?? "";
                obj["ZD Name"] = obj["zdName"] ?? "";
                obj["RDS"] = obj["parentId"] ?? "";
                obj["RDS Name"] = obj["parentName"] ?? "";
                obj["Retailer"] = obj["retailerId"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["retailerCnt"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["ZD"] = obj["zd"] ?? "";
                obj["ZD Name"] = obj["zdName"] ?? "";
                obj["RDS"] = obj["rds"] ?? "";
                obj["RDS Name"] = obj["rdsName"] ?? "";
                obj["Retailer"] = obj["retailerId"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                obj["Status"] = obj["status"] ?? "";
                obj["LMTD Status"] = obj["lmtdBilled"] ?? "";
                obj["Billed Status"] = obj["mtdBilled"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtdBilled"];
                delete obj["mtdBilled"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["ard"];
                delete obj["ardName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                return obj;
              });
          },
        }[tile]());
        return csv;
      },
      MARD: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jioCenter"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["MARD Code"] = obj["parentId"] ?? "";
                obj["MARD Name"] = obj["parentName"] ?? "";
                obj["UAO Code"] = obj["retailerId"] ?? "";
                obj["UAO Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["retailerCnt"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["JC Code"] = obj["jioCenter"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["MARD Code"] = obj["ard"] ?? "";
                obj["MARD Name"] = obj["ardName"] ?? "";
                obj["UAO Code"] = obj["retailerId"] ?? "";
                obj["UAO Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                obj["Status"] = obj["status"] ?? "";
                obj["LMTD Status"] = obj["lmtdBilled"] ?? "";
                obj["Billed Status"] = obj["mtdBilled"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtdBilled"];
                delete obj["mtdBilled"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["ard"];
                delete obj["ardName"];
                return obj;
              });
            return csv;
          },
        }[tile]());
        return csv;
      },
      RZD: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["RZD"] = obj["parentId"] ?? "";
                obj["RZD Name"] = obj["parentName"] ?? "";
                obj["DRS Code"] = obj["retailerId"] ?? "";
                obj["DRS Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                obj["DRS Count"] = obj["retailerCnt"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["retailerCnt"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["RZD"] = obj["ard"] ?? "";
                obj["RZD Name"] = obj["ardName"] ?? "";
                obj["DRS Code"] = obj["retailerId"] ?? "";
                obj["DRS Name"] = obj["retailerName"] ?? "";
                obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                obj["Status"] = obj["status"] ?? "";
                obj["LMTD Status"] = obj["lmtdBilled"] ?? "";
                obj["Billed Status"] = obj["mtdBilled"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailerId"];
                delete obj["retailerName"];
                delete obj["jprTypeName"];
                delete obj["status"];
                delete obj["lmtdBilled"];
                delete obj["mtdBilled"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["ard"];
                delete obj["ardName"];
                delete obj["rds"];
                delete obj["rdsName"];
                return obj;
              });
            return csv;
          },
        }[tile]());
        return csv;
      },
      ITZ: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["IT ZD Code"] = obj["zd"] ?? "";
                obj["IT ZD Name"] = obj["zdName"] ?? "";
                obj["ITD Code"] = obj["parentId"] ?? "";
                obj["ITD Name"] = obj["parentName"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["retailerId"];
                delete obj["jprTypeName"];
                delete obj["retailerCnt"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["IT ZD Code"] = obj["zd"] ?? "";
                obj["IT ZD Name"] = obj["zdName"] ?? "";
                obj["ITD Code"] = obj["rds"] ?? "";
                obj["ITD Name"] = obj["rdsName"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JC Code"] = obj["jioCenter"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["Status"] = obj["status"] ?? "";
                obj["LMTD Status"] = obj["lmtdBilled"] ?? "";
                obj["Billed Status"] = obj["mtdBilled"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["status"];
                delete obj["lmtdBilled"];
                delete obj["mtdBilled"];
                delete obj["retailerId"];
                delete obj["jprTypeName"];
                delete obj["ard"];
                delete obj["ardName"];
                return obj;
              });
            return csv;
          },
        }[tile]());
        return csv;
      },
      ITD: () => {
        ({
          billed: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["IT ZD Code"] = obj["zd"] ?? "";
                obj["IT ZD Name"] = obj["zdName"] ?? "";
                obj["ITD Code"] = obj["parentId"] ?? "";
                obj["ITD Name"] = obj["parentName"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["parentId"];
                delete obj["parentName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["retailerId"];
                delete obj["jprTypeName"];
                delete obj["retailerCnt"];
                return obj;
              });
            return csv;
          },
          onboard: () => {
            csv =
              content &&
              content.map((obj) => {
                obj["Region"] = obj["region"] ?? "";
                obj["State"] = obj["state"] ?? "";
                obj["IT ZD Code"] = obj["zd"] ?? "";
                obj["IT ZD Name"] = obj["zdName"] ?? "";
                obj["ITD Code"] = obj["rds"] ?? "";
                obj["ITD Name"] = obj["rdsName"] ?? "";
                obj["Retailer"] = obj["retailer"] ?? "";
                obj["Retailer Name"] = obj["retailerName"] ?? "";
                obj["JC Code"] = obj["jioCenter"] ?? "";
                obj["JC Name"] = obj["jcName"] ?? "";
                obj["Status"] = obj["status"] ?? "";
                obj["LMTD Status"] = obj["lmtdBilled"] ?? "";
                obj["Billed Status"] = obj["mtdBilled"] ?? "";
                delete obj["region"];
                delete obj["state"];
                delete obj["zd"];
                delete obj["zdName"];
                delete obj["rds"];
                delete obj["rdsName"];
                delete obj["retailer"];
                delete obj["retailerName"];
                delete obj["jioCenter"];
                delete obj["jcName"];
                delete obj["status"];
                delete obj["lmtdBilled"];
                delete obj["mtdBilled"];
                delete obj["retailerId"];
                delete obj["jprTypeName"];
                delete obj["ard"];
                delete obj["ardName"];
                return obj;
              });
            return csv;
          },
        }[tile]());
        return csv;
      },
      JPT:() =>{
        ({
          billed:()=>{
            csv= content && content.map(obj =>{
              obj['Region']=obj['region'] ?? "";
              obj['State']=obj['state'] ?? "";
              obj['Jio Point Id']=obj['jio_point_id'] ?? "";
              obj['Jio Point Name']=obj['jio_point_name'] ?? "";
              obj['Retailer Id']=obj['retailerid'] ?? "";
              obj['Retailer Name']=obj['retailername'] ?? "";
              obj['JPR TYPE NAME']=obj['jpr_type_name'] ?? "";
              delete obj['region']
              delete obj['state']
              delete obj['jio_point_id']
              delete obj['jio_point_name']
              delete obj['retailerid']
              delete obj['retailername']
              delete obj['retailer_count']
              delete obj['jpr_type_name'] 
              return obj;
            })
            return csv ;
          },
          onboard:()=>{
            csv= content && content.map(obj =>{
              obj['Region']=obj['region'] ?? "";
              obj['State']=obj['state'] ?? "";
              obj['JC ID']=obj['jioCenter'] ?? "";
              obj['JC Name']=obj['jcName'] ?? "";
              obj['Jio Point Id']=obj['jio_point_id'] ?? "";
              obj['Jio Point Name']=obj['jio_point_name'] ?? "";
              obj['Retailer Id']=obj['retailerId'] ?? "";
              obj['Retailer Name']=obj['retailerName'] ?? "";
              obj['Status']=obj['status'] ?? "";
              obj['MTD Billed']=obj['mtdBilled'] ?? "";
              obj['LMTD Billed']=obj['lmtdBilled'] ?? "";
              delete obj['region']
              delete obj['state']
              delete obj['jioCenter'] 
              delete obj['jcName']
              delete obj['jio_point_id']
              delete obj['jio_point_name']
              delete obj['retailerId']
              delete obj['retailerName']
              delete obj['status']
              delete obj['mtdBilled'] 
              delete obj['lmtdBilled']
              delete obj['jprTypeName']
              return obj;
            })
            return csv ;
          }
        }[tile]());
        return csv;
      },
      JP:()=>{
        ({
          billed:()=>{
            csv= content && content.map(obj =>{
              obj['Region']=obj['region'] ?? "";
              obj['State']=obj['state'] ?? "";
              obj['Jio Point Id']=obj['jio_point_id'] ?? "";
              obj['Jio Point Name']=obj['jio_point_name'] ?? "";
              obj['Retailer Id']=obj['retailerid'] ?? "";
              obj['Retailer Name']=obj['retailername'] ?? "";
              obj['JPR TYPE NAME']=obj['jpr_type_name'] ?? "";
              delete obj['region']
              delete obj['state']
              delete obj['jio_point_id']
              delete obj['jio_point_name']
              delete obj['retailerid']
              delete obj['retailername']
              delete obj['retailer_count']
              delete obj['jpr_type_name'] 
              return obj;
            })
            return csv ;
          },
          onboard:()=>{
            csv= content && content.map(obj =>{
              obj['Region']=obj['region'] ?? "";
              obj['State']=obj['state'] ?? "";
              obj['JC ID']=obj['jioCenter'] ?? "";
              obj['JC Name']=obj['jcName'] ?? "";
              obj['Jio Point Id']=obj['jio_point_id'] ?? "";
              obj['Jio Point Name']=obj['jio_point_name'] ?? "";
              obj['Retailer Id']=obj['retailerId'] ?? "";
              obj['Retailer Name']=obj['retailerName'] ?? "";
              obj['Status']=obj['status'] ?? "";
              obj['MTD Billed']=obj['mtdBilled'] ?? "";
              obj['LMTD Billed']=obj['lmtdBilled'] ?? "";
              delete obj['region']
              delete obj['state']
              delete obj['jioCenter'] 
              delete obj['jcName']
              delete obj['jio_point_id']
              delete obj['jio_point_name']
              delete obj['retailerId']
              delete obj['retailerName']
              delete obj['status']
              delete obj['mtdBilled'] 
              delete obj['lmtdBilled']
              delete obj['jprTypeName']
              return obj;
            })
            return csv ;
          }
        }[tile]());
        return csv;
      }
    }[role]());
    return csv;
  };